import { useRef, useEffect } from 'react';

const DIFFERENTIALS = [
  {
    number: '01',
    icon: 'ri-award-line',
    title: 'Atendimento Estratégico',
    desc: 'Cada consulta é tratada com profundidade estratégica, unindo conhecimento técnico jurídico à visão prática para soluções eficazes.',
  },
  {
    number: '02',
    icon: 'ri-eye-line',
    title: 'Visão Analítica e Técnica',
    desc: 'Análise criteriosa e fundamentada de cada situação, com diagnóstico preciso e orientação clara sobre os caminhos jurídicos disponíveis.',
  },
  {
    number: '03',
    icon: 'ri-lock-line',
    title: 'Segurança Jurídica',
    desc: 'Atuação pautada na legalidade, ética e rigor técnico para garantir segurança jurídica em todas as orientações prestadas.',
  },
  {
    number: '04',
    icon: 'ri-user-heart-line',
    title: 'Atendimento Direto com o Advogado',
    desc: 'Você fala diretamente com Dr. Diogo de Calasans, sem intermediários, garantindo comunicação clara e relacionamento de confiança.',
  },
  {
    number: '05',
    icon: 'ri-compass-3-line',
    title: 'Foco na Solução e Prevenção',
    desc: 'Postura proativa na identificação e prevenção de riscos, buscando sempre a melhor solução para cada contexto jurídico.',
  },
];

export default function DifferentialsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );
    sectionRef.current?.querySelectorAll('.anim').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="diferenciais" className="py-32 bg-[#EAF0F4]" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16 anim opacity-0 translate-y-8 transition-all duration-700">
          <p className="text-[#C6935A] text-xs font-600 tracking-[3px] uppercase mb-4">
            Por que nos escolher
          </p>
          <h2 className="text-4xl lg:text-5xl font-700 text-[#1F4B63] leading-tight mb-4">
            Nossos Diferenciais
          </h2>
          <div className="w-16 h-0.5 bg-[#C6935A] mx-auto mt-4" />
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {DIFFERENTIALS.map((item, i) => (
            <div
              key={item.number}
              className={`anim opacity-0 translate-y-8 transition-all duration-700 ${
                i === 3 ? 'lg:col-start-1' : ''
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="bg-white rounded-2xl p-10 h-full relative overflow-hidden group hover:-translate-y-1.5 transition-transform duration-300 cursor-default">
                {/* Big background number */}
                <span
                  className="absolute top-4 right-6 text-[120px] font-800 text-[#1F4B63] leading-none select-none"
                  style={{ opacity: 0.04 }}
                >
                  {item.number}
                </span>

                {/* Title */}
                <h3 className="text-[#1F4B63] font-700 text-xl mb-3">{item.title}</h3>

                {/* Desc */}
                <p className="text-[#4A5568] text-sm leading-relaxed">{item.desc}</p>

                {/* Bottom accent */}
                <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C6935A] group-hover:w-full transition-all duration-500" />
              </div>
            </div>
          ))}

          {/* Final CTA Card */}
          <div
            className="anim opacity-0 translate-y-8 transition-all duration-700"
            style={{ transitionDelay: '500ms' }}
          >
            <div className="bg-[#1F4B63] rounded-2xl p-10 h-full flex flex-col items-start justify-center">
              <i className="ri-question-answer-line text-[#D4A873] text-3xl mb-6" />
              <h3 className="text-white font-700 text-xl mb-3">Tem alguma dúvida?</h3>
              <p className="text-white/70 text-sm leading-relaxed mb-8">
                Entre em contato e receba orientação jurídica clara e objetiva para o seu caso.
              </p>
              <a
                href="https://wa.me/5579999778899?text=Olá,%20gostaria%20de%20tirar%20uma%20dúvida."
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-[#C6935A] hover:bg-[#A8763F] text-white font-600 px-6 py-3 rounded-full transition-all duration-300 text-sm whitespace-nowrap"
              >
                <i className="ri-whatsapp-line" />
                Fale Conosco
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
